module.exports = __webpack_public_path__ + "static/media/10get.ffbdccdd.svg";